// extracted by mini-css-extract-plugin
module.exports = {"reportModal":"index_reportModal__GBdaO","subText":"index_subText__K9kVJ"};